import React from "react";
import { Doughnut } from "react-chartjs-2";
import Card from "../../components/Custom/Card/Card";
import CardBody from "../../components/Custom/Card/CardBody";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  card: {
    border: "1px solid #e0e0e0", // Faint gray border color
    width: "115%",
  },
});

const DoughnutChart = (props) => {
  const classes = useStyles();
  const pieData = [];

  if (props.txnSummary != null) {
    var total =
      props.txnSummary.responseObject.successfulTxnAmount +
      props.txnSummary.responseObject.declinedTxnAmount +
      props.txnSummary.responseObject.refundTxnAmount +
      props.txnSummary.responseObject.chbkTxnAmount +
      props.txnSummary.responseObject.successfulSettledAmount;

    if (props.txnSummary.successfulTxnAmount !== 0)
      pieData.push(
        (
          100 /
          (total / props.txnSummary.responseObject.successfulTxnAmount)
        ).toFixed(2)
      );
    else pieData.push(0);

    if (props.txnSummary.successfulSettledCount !== 0)
      pieData.push(
        (
          100 /
          (total / props.txnSummary.responseObject.successfulSettledAmount)
        ).toFixed(2)
      );
    else pieData.push(0);

    if (props.txnSummary.declinedTxnAmount !== 0)
      pieData.push(
        (
          100 /
          (total / props.txnSummary.responseObject.declinedTxnAmount)
        ).toFixed(2)
      );
    else pieData.push(0);

    if (props.txnSummary.chbkTxnCount !== 0)
      pieData.push(
        (100 / (total / props.txnSummary.responseObject.chbkTxnAmount)).toFixed(
          2
        )
      );
    else pieData.push(0);

    if (props.txnSummary.refundTxnAmount !== 0)
      pieData.push(
        (
          100 /
          (total / props.txnSummary.responseObject.refundTxnAmount)
        ).toFixed(2)
      );
    else pieData.push(0);
  }

  return (
    <Card color="white" className={classes.card}>
      <CardBody>
        <Doughnut
          data={{
            labels: [
              "Succesful",
              "Settled",
              "Declined",
              "Chargebacks",
              "Refunds",
            ],
            datasets: [
              {
                label: "Count",
                data: pieData,
                backgroundColor: [
                  "#234B77",
                  "rgb(173, 206, 171)",
                  "#ad4e91",
                  "rgb(153, 65, 65)",
                  "rgba(239, 192, 4, 0.91)",
                ],
                borderColor: ["black", "black", "black", "black", "black"],
                borderWidth: 1,
              },
            ],
          }}
          height={300}
          width={420}
          options={{
            maintainAspectRatio: false,

            scales: {
              xAxes: [
                {
                  barThickness: 50,
                  maxBarThickness: 50,
                  width: 50,
                },
              ],
              yAxes: [
                {
                  ticks: {
                    beginAtZero: true,
                  },
                },
              ],
            },
            legend: {
              position: "bottom",

              labels: {
                fontSize: 25,
              },
            },
          }}
        />
      </CardBody>
    </Card>
  );
};

export default DoughnutChart;
